import React from "react";
import moment from "moment/moment";

import LiveRate from "./LiveRate";
import ProfitLoss from "./ProfitLoss";
import TimeTick from "./Time";

export default function StandingCard({ item, userType, total }) {
  const OpenEdit = () => {
    window.user_id = item.user_id;
    window.userModalOpen();
  };

  const OpenEditMaster = () => {
    window.user_id = item.master_id;
    window.masterModalOpen();
  };

  const OpenEditSuper = () => {
    window.user_id = item.super_id;
    window.openeditSuper();
  };

  return (
    <li key={item.id} className={`menuContainer addHight text `}>
      <div className="menuExchange">
        {item.type === "nse"
          ? "NSE"
          : item.type === "mcx"
          ? "MCX"
          : item.type === "fo"
          ? "OPTIONS"
          : item.type === "nse_cash"
          ? "NSE-EQUITY"
          : item.type === "comex_future"
          ? "COMEX"
          : item.type === "crypto_future"
          ? "CRYPTO"
          : item.type === "forex_future"
          ? "FOREX"
          : "NSE"}
      </div>
      {userType === 1 && (
        <div onClick={OpenEditSuper} className="menuExchange uppercase">
          <div className="user_id">{item.super_username}</div>
        </div>
      )}
      {(userType === 1 || userType === 2) && (
        <div onClick={OpenEditMaster} className="menuExchange uppercase">
          <div className="user_id">{item.master_username}</div>
        </div>
      )}
      {(userType === 1 || userType === 2 || userType === 3) && (
        <div onClick={OpenEdit} className="menuExchange uppercase">
          <div className="user_id">{item.username}</div>
        </div>
      )}

      <div className="menuExchange">{item.symbol}</div>
      <div className="menuExpiry">
        {item.type === "nse_cash"
          ? "EQUITY"
          : moment(item.expiry_date).format("DD-MMM")}
      </div>
      <div className="menuBuyPrice">
        <div
          className={`menuBuyPrice ${
            item.buy_sell === 0 ? "buytext" : "selltext"
          }`}
        >
          {item.buy_sell === 0 ? "BUY" : "SELL"}
        </div>
      </div>
      <div className={`menuBuyPrice`}>{item.qty}</div>

      <div className={`menuBuyPrice`}>{item.rate}</div>
      <div className="menuBuyPrice ">
        <LiveRate symbol_id={item.symbol_id} buy_sell={item.buy_sell} />
      </div>
      <div className="menuBuyQty">
        <ProfitLoss
          symbol_id={item.symbol_id}
          item={item}
          total={total}
        />
      </div>
      <div className="menuLtt">
        <TimeTick symbol_id={item.symbol_id} />
      </div>
    </li>
  );
}
